import { render, staticRenderFns } from "./OverseasExhibition.vue?vue&type=template&id=b2489d64&scoped=true"
import script from "./OverseasExhibition.vue?vue&type=script&lang=js"
export * from "./OverseasExhibition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2489d64",
  null
  
)

export default component.exports